<div class="tabs">
  <nav
    mat-tab-nav-bar
    class="themed-tab-nav">
    <a
      mat-tab-link
      *ngFor="let tab of tabs$ | async"
      (click)="switchTab(tab.value)"
      [active]="(tabParam$ | async) == tab.value"
      [attr.data-cy]="'state-' + tab.value + '-toggle-button'">
      {{ tab.label | i18n }}
    </a>
  </nav>
</div>
<div>
  <p>
    {{
      ("agencyPrioritiesDescription" | i18n) || "agency priorities description"
    }}
  </p>
</div>
<div
  class="conditional-transfers-list"
  *ngIf="user$ | async">
  <mat-card
    class="mat-elevation-z2"
    *ngFor="let priority of activePriorities$ | async; let i = index">
    <mat-card-content>
      <div class="row">
        <div class="col-2 col-md-1 priority-input">
          <button
            type="button"
            class="movement-chevron"
            [disabled]="i === 0"
            (click)="increasePriority(i)">
            <mat-icon
              svgIcon="chevron-down"
              class="rotate"></mat-icon>
          </button>
          <span class="index-count"> {{ i + 1 }} </span>
          <button
            type="button"
            class="movement-chevron"
            [disabled]="i === ((activePriorities$ | async)?.length ?? 0) - 1"
            (click)="decreasePriority(i)">
            <mat-icon svgIcon="chevron-down"></mat-icon>
          </button>
        </div>
        <div class="col-10 col-md-8">
          {{ priority.customerName }}
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
<div class="floating-actions-bar">
  <button
    (click)="cancelChanges()"
    class="secondary-pill-button icon-left big-fab"
    type="button"
    data-cy="cancel-conditional-transfers-button">
    <mat-icon svgIcon="close"></mat-icon>
    {{ ("cancel" | i18n) || "cancel" | titlecase }}
  </button>
  <button
    (click)="saveAgencyPriorities()"
    class="primary-pill-button icon-left big-fab"
    type="button"
    data-cy="save-conditional-transfers-button">
    <mat-icon svgIcon="save"></mat-icon>
    {{ ("save" | i18n) || "save" | titlecase }}
  </button>
</div>
